import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=efc83f88&scoped=true"
import script from "./Index.ts?vue&type=script&lang=js&external"
export * from "./Index.ts?vue&type=script&lang=js&external"
import style0 from "./Index.less?vue&type=style&index=0&id=efc83f88&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc83f88",
  null
  
)

export default component.exports